export interface OrderDisplayNumberSource {
  id: string;
  orderNumber?: string | undefined;
}

export interface OrderDisplayReference {
  label: "业务单号" | "历史记录标识";
  value: string;
}

export function orderDisplayReference(order: OrderDisplayNumberSource): OrderDisplayReference {
  return order.orderNumber && order.orderNumber !== order.id
    ? { label: "业务单号", value: order.orderNumber }
    : { label: "历史记录标识", value: order.id };
}
